
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { makeFormModel, setState, getChildModel } from 'ah-common-lib/src/form/helpers';
import { selectField } from 'ah-common-lib/src/form/models';

const numberOfRowsFM = () =>
  makeFormModel({
    name: 'numberOfRowsSelector',
    fieldType: 'form',
    fields: [
      selectField('numberOfRows', 'Display', [], {
        placeholder: 'Display...',
        fieldWrapperClass: 'col col-12 mb-0',
      }),
    ],
    state: {
      hideErrors: true,
    },
  });

const defaultNumberOfRowsOptions: { label: string; value: number }[] = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '50', value: 50 },
];

@Component
export default class SizeSelector extends Vue {
  @Prop({ default: 10 }) selectedValue!: number;

  @Prop({ default: () => defaultNumberOfRowsOptions }) customRowsOptions!: { label: string; value: number }[];

  private pageNumberSelectForm = numberOfRowsFM();

  @Watch('customRowsOptions', { immediate: true })
  onCustomRowOptionsChange() {
    setState(getChildModel(this.pageNumberSelectForm, 'numberOfRows')!, 'options', this.customRowsOptions);
  }

  @Watch('selectedValue', { immediate: true })
  onPropsChange() {
    this.pageNumberSelectForm.numberOfRows = this.selectedValue;
  }

  @Watch('pageNumberSelectForm.numberOfRows', { immediate: true })
  onValueChange() {
    this.$emit('update:selected-value', this.pageNumberSelectForm.numberOfRows);
  }
}
